import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'web-ui-components/lib/atoms/popovers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

export const RenderPopper = ({ id, content, isOpen, togglePopover }) => (
	<Popover
		id={`popover_${id}`}
		className="u-margin-left-1"
		isOpen={isOpen || false}
		onClick={() => togglePopover(id)}
		placement="top"
		content={content}
	>
		<Icon iconType="InfoOutlineLarge" size="xs" />
	</Popover>
);

RenderPopper.propTypes = {
	id: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	isOpen: PropTypes.boolean,
	togglePopover: PropTypes.func.isRequired,
};
